var template = require('../templates/App.html');

module.exports = Backbone.View.extend({
    // Instead of generating a new element, bind to the existing skeleton of
    // the App already present in the HTML.
    el: $('body'),

    initialize: function() {
        this.render();

        $(window).on('resize', function() {
            $('body').toggleClass('mini-navbar', $(this).width() < 1200);
        });

        $(document).on('keydown', function(e) {
            if (e.which === 8 && !$(e.target).is('input:not([readonly])' +
                    ':not([type=radio]):not([type=checkbox]), textarea, ' +
                    '[contentEditable], [contentEditable=true]')) {
                e.preventDefault();
            }
        });

        return this;
    },

    render: function() {
        this.$el.append(template());

        $(window).trigger('resize');

        return this;
    }
});



// WEBPACK FOOTER //
// ./app/views/App.js